module.exports = __webpack_public_path__ + "img/bank-garanti.fb58ffc0.svg";